// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Open Positions — styled per DESIGN_SYSTEM.md (June 2026)
 * Reference implementation: Equity.css
 * Rollback: rename OpenPositions.legacy.css → OpenPositions.css
 */

/* ── Page container ──────────────────────────────────────────────────────── */

.open-positions-container {
  padding: 1rem;
  max-width: 100%;
  box-sizing: border-box;
  background: #f5f7fa;
  min-height: 100vh;
  font-feature-settings: 'tnum' 1;
  -webkit-font-smoothing: antialiased;
}

.open-positions-content {
  width: 100%;
}

/* ── Controls / filter bar ───────────────────────────────────────────────── */

.open-positions-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  margin-bottom: 1rem;
}

.account-selector,
.broker-selector,
.type-selector {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.account-selector label,
.broker-selector label,
.type-selector label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
}

.account-selector select,
.broker-selector select,
.type-selector select {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  background: #ffffff;
  color: #111827;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-width: 150px;
}

.account-selector select:hover,
.broker-selector select:hover,
.type-selector select:hover {
  border-color: #9ca3af;
}

.account-selector select:focus,
.broker-selector select:focus,
.type-selector select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);
}

.synthetic-checkbox {
  display: flex;
  align-items: center;
}

.synthetic-checkbox label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
}

.synthetic-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #667eea;
}

/* ── Table container ─────────────────────────────────────────────────────── */

.open-positions-table-container {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  overflow-x: auto;
  overflow-y: visible;
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
}

/* ── Desktop scroll wrapper ──────────────────────────────────────────────── */

.op-desktop {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── Table ───────────────────────────────────────────────────────────────── */

.open-positions-table {
  width: auto;
  border-collapse: collapse;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
  table-layout: auto;
}

/* ── Table header — light gray, never gradient ───────────────────────────── */

.open-positions-table thead {
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.open-positions-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  transition: background-color 0.15s;
  font-variant-numeric: tabular-nums;
}

.open-positions-table th:hover {
  background: #f3f4f6;
}

.sort-icon {
  margin-left: 0.4rem;
  color: #9ca3af;
  font-size: 0.75rem;
}

.open-positions-table th:hover .sort-icon {
  color: #6b7280;
}

/* ── Table body ──────────────────────────────────────────────────────────── */

.open-positions-table tbody tr {
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.15s;
}

.open-positions-table tbody tr:hover {
  background: #f9fafb;
}

.open-positions-table tbody tr:last-child {
  border-bottom: none;
}

/* ── Table cells ─────────────────────────────────────────────────────────── */

.open-positions-table td {
  padding: 0.4375rem 0.75rem;
  color: #111827;
  white-space: nowrap;
  position: relative;
  font-variant-numeric: tabular-nums;
  text-align: left;
  vertical-align: middle;
}

/* ── Option type — left-border accent ───────────────────────────────────── */

.open-positions-table tbody tr.row-call {
  border-left: 3px solid #3b82f6;
}

.open-positions-table tbody tr.row-put {
  border-left: 3px solid #f97316;
}

.open-positions-table tbody tr.synthetic-row {
  border-left: 3px solid #7c3aed;
}

/* ── Group / section headers ─────────────────────────────────────────────── */

.group-header-row {
  background: #f9fafb;
  border-top: 2px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
}

.group-header-cell {
  padding: 0.375rem 0.75rem !important;
  font-size: 0.6875rem !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #374151;
  background: inherit;
  line-height: 1.2;
}

/* Subtle tinted section headers — left-border accent instead of full fill */
.group-header-row.short_calls-header {
  border-left: 4px solid #dc2626;
}
.group-header-row.short_calls-header .group-header-cell {
  color: #991b1b;
}

.group-header-row.long_calls-header {
  border-left: 4px solid #3b82f6;
}
.group-header-row.long_calls-header .group-header-cell {
  color: #1e40af;
}

.group-header-row.short_puts-header {
  border-left: 4px solid #f97316;
}
.group-header-row.short_puts-header .group-header-cell {
  color: #9a3412;
}

.group-header-row.long_puts-header {
  border-left: 4px solid #059669;
}
.group-header-row.long_puts-header .group-header-cell {
  color: #065f46;
}

.group-header-row.synthetic-header {
  border-left: 4px solid #7c3aed;
}
.group-header-row.synthetic-header .group-header-cell {
  color: #5b21b6;
}

.group-header-row.other-header {
  border-left: 4px solid #6b7280;
}
.group-header-row.other-header .group-header-cell {
  color: #374151;
}

/* ── Cell types ──────────────────────────────────────────────────────────── */

.account-cell {
  font-weight: 500;
  color: #374151;
}

.symbol-cell {
  font-weight: 600;
  color: #111827;
}

.date-cell {
  color: #374151;
}

.expiry-cell {
  color: #374151;
}

.moneyness-cell {
  text-align: center;
}

.number-cell {
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.number-cell.positive {
  color: #059669;
  font-weight: 600;
}

.number-cell.negative {
  color: #dc2626;
  font-weight: 600;
}

.number-cell.vsp-orange {
  color: #d97706;
  font-weight: 600;
}

/* Tags cell — constrained width */
.open-positions-table .tags-cell {
  white-space: nowrap;
  min-width: 60px;
  max-width: 130px;
}

/* ── Delta / Greek colour indicators — soft modern tones ─────────────────── */

.open-positions-table td.number-cell.delta-green {
  background: rgba(5, 150, 105, 0.10);
  color: #065f46;
  font-weight: 600;
}

.open-positions-table td.number-cell.delta-orange {
  background: rgba(217, 119, 6, 0.10);
  color: #92400e;
  font-weight: 600;
}

.open-positions-table td.number-cell.delta-red {
  background: rgba(220, 38, 38, 0.10);
  color: #991b1b;
  font-weight: 600;
}

/* ── Moneyness badges ────────────────────────────────────────────────────── */

.moneyness-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.moneyness-badge.moneyness-green {
  background: #d1fae5;
  color: #065f46;
}

.moneyness-badge.moneyness-red {
  background: #fee2e2;
  color: #991b1b;
}

.moneyness-badge.moneyness-orange {
  background: #fef3c7;
  color: #92400e;
}

.moneyness-badge.moneyness-gray {
  background: #f3f4f6;
  color: #374151;
}

/* ── Total / summary rows ────────────────────────────────────────────────── */

.total-row td {
  font-weight: 700;
  border-top: 2px solid #e5e7eb;
  background: #f9fafb;
}

.total-label {
  font-weight: 700;
  color: #111827;
}

/* ── Section header (mobile section labels) ──────────────────────────────── */

.section-header td {
  background: #f9fafb;
  font-weight: 700;
  font-size: 0.6875rem;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 0.375rem 0.75rem;
  border-top: 2px solid #e5e7eb;
  border-bottom: 1px solid #e5e7eb;
}

/* ── Expand button ───────────────────────────────────────────────────────── */

.expand-button {
  background: #667eea;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;
}

.expand-button:hover {
  background: #5a6fd8;
}

/* ── OptionStrat link ────────────────────────────────────────────────────── */

.optionstrat-link {
  color: #3b82f6;
  text-decoration: none;
  font-size: 0.75rem;
}

.optionstrat-link:hover {
  text-decoration: underline;
  color: #2563eb;
}

.optionstrat-nvt {
  color: #9ca3af;
  font-size: 0.75rem;
}

/* ── No tags indicator ───────────────────────────────────────────────────── */

.no-tags {
  color: #9ca3af;
  font-size: 0.75rem;
  font-style: italic;
}

/* ── Delta warning icon ──────────────────────────────────────────────────── */

.delta-warning-icon {
  color: #d97706;
  margin-left: 4px;
  font-size: 0.75rem;
}

/* ── Info icon ───────────────────────────────────────────────────────────── */

.info-icon {
  color: #9ca3af;
  cursor: help;
  font-size: 0.75rem;
  margin-left: 4px;
}

/* ── Tooltip ─────────────────────────────────────────────────────────────── */

.cell-tooltip {
  position: absolute;
  background: #111827;
  color: #ffffff;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  z-index: 1000;
  white-space: nowrap;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  line-height: 1.4;
}

/* ── Short call exposure table ───────────────────────────────────────────── */

.short-call-exposure-container {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #e5e7eb;
  padding: 1rem;
  margin-bottom: 1rem;
}

.short-call-exposure-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
}

.short-call-exposure-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
  white-space: nowrap;
}

.short-call-exposure-table td {
  padding: 0.4375rem 0.75rem;
  border-bottom: 1px solid #f3f4f6;
  color: #111827;
}

.short-call-exposure-table tbody tr:hover {
  background: #f9fafb;
}

.short-call-exposure-table th.sortable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s;
}

.short-call-exposure-table th.sortable-header:hover {
  background: #f3f4f6;
}

.short-call-exposure-table th.sortable-header .sort-icon {
  display: inline-block;
  margin-left: 4px;
  font-size: 0.9em;
  vertical-align: middle;
  color: #9ca3af;
}

.short-call-exposure-table th.sortable-header:hover .sort-icon {
  color: #6b7280;
}

.short-call-exposure-table .exposure-cell {
  color: #dc2626;
  font-weight: 600;
  text-align: right;
}

.short-call-exposure-table .total-row {
  font-weight: 700;
  background: #f9fafb;
  border-top: 2px solid #e5e7eb;
}

.short-call-exposure-table .total-row .total-exposure {
  color: #dc2626;
  font-weight: 700;
}

/* ── Loading / error / empty ─────────────────────────────────────────────── */

.loading {
  padding: 3rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
}

.error {
  padding: 1rem;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  border-radius: 8px;
  color: #b91c1c;
  margin-bottom: 1rem;
}

.empty-state {
  padding: 3rem 1rem;
  text-align: center;
  color: #9ca3af;
  font-style: italic;
}

/* ── Mobile / Desktop split ──────────────────────────────────────────────── */

.op-mobile {
  display: none;
}

@media (max-width: 768px) {
  .op-desktop {
    display: none;
  }

  .op-mobile {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .open-positions-container {
    padding: 0;
    background: #f5f7fa;
  }

  .open-positions-content {
    padding: 0;
  }

  .short-call-exposure-container {
    margin-top: 0;
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    border: none;
    border-top: 1px solid #e5e7eb;
  }

  .open-positions-controls {
    flex-direction: column;
    gap: 6px;
    padding: 8px;
    margin-bottom: 0;
    border-radius: 0;
    box-shadow: none;
    border-left: none;
    border-right: none;
    border-top: none;
  }

  .open-positions-controls .account-selector,
  .open-positions-controls .broker-selector,
  .open-positions-controls .type-selector {
    width: 100%;
  }

  .open-positions-controls select {
    width: 100%;
    min-width: unset;
    box-sizing: border-box;
    padding: 6px 8px;
    font-size: 0.8125rem;
  }

  .account-selector select,
  .broker-selector select,
  .type-selector select {
    min-width: unset;
  }

  .open-positions-controls .synthetic-checkbox {
    align-self: flex-start;
  }

  /* Mobile table */
  .op-mobile-table {
    width: 100%;
    min-width: 310px;
    border-collapse: collapse;
    font-size: 0.75rem;
    font-variant-numeric: tabular-nums;
    table-layout: auto;
  }

  .op-mobile-table thead {
    background: #f9fafb;
    border-bottom: 2px solid #e5e7eb;
  }

  .op-mobile-table th {
    padding: 0.375rem 0.5rem;
    background: #f9fafb;
    text-align: left;
    font-size: 0.625rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #374151;
    border-bottom: 2px solid #e5e7eb;
    white-space: nowrap;
  }

  .op-mobile-table td {
    padding: 0.375rem 0.5rem;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    white-space: nowrap;
    color: #111827;
  }

  .op-mobile-table td:first-child {
    font-weight: 600;
  }

  .op-mobile-table tbody tr:hover {
    background: #f9fafb;
  }

  .op-mobile-table .positive {
    color: #059669;
    font-weight: 600;
  }

  .op-mobile-table .negative {
    color: #dc2626;
    font-weight: 600;
  }

  .op-mobile-table .row-call {
    border-left: 3px solid #3b82f6;
  }

  .op-mobile-table .row-put {
    border-left: 3px solid #f97316;
  }

  .op-mobile-table .section-header td {
    background: #f9fafb;
    font-weight: 700;
    font-size: 0.6rem;
    color: #374151;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    padding: 0.375rem 0.5rem;
    border-top: 2px solid #e5e7eb;
    border-left: none;
  }
}

/* ── Wide screens ────────────────────────────────────────────────────────── */

@media (max-width: 1400px) {
  .open-positions-table {
    font-size: 0.75rem;
  }

  .open-positions-table th,
  .open-positions-table td {
    padding: 0.375rem 0.5rem;
  }
}

/* Live positions (position.is_live - seen via the IBKR API today, merged in
   by OpenPositionViewSet, not yet in tonight's Flex import). Same row/table
   as every other position - just a tint + a small badge, not a separate
   section. */
.live-position-row {
  background-color: #eef4ff;
}

.live-position-badge {
  display: inline-block;
  margin-left: 0.4rem;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #26314f;
  background: #c9dcff;
  border-radius: 4px;
  padding: 0.05rem 0.35rem;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/OpenPositions.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,+EAA+E;;AAE/E;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,8EAA8E;;AAE9E;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;IACxB,6BAA6B;IAC7B,iBAAiB;EACnB;AACF;;AAEA,+EAA+E;;AAE/E;EACE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;;aAGa;AACb;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB","sourcesContent":["/*\n * Open Positions — styled per DESIGN_SYSTEM.md (June 2026)\n * Reference implementation: Equity.css\n * Rollback: rename OpenPositions.legacy.css → OpenPositions.css\n */\n\n/* ── Page container ──────────────────────────────────────────────────────── */\n\n.open-positions-container {\n  padding: 1rem;\n  max-width: 100%;\n  box-sizing: border-box;\n  background: #f5f7fa;\n  min-height: 100vh;\n  font-feature-settings: 'tnum' 1;\n  -webkit-font-smoothing: antialiased;\n}\n\n.open-positions-content {\n  width: 100%;\n}\n\n/* ── Controls / filter bar ───────────────────────────────────────────────── */\n\n.open-positions-controls {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  margin-bottom: 1rem;\n}\n\n.account-selector,\n.broker-selector,\n.type-selector {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.account-selector label,\n.broker-selector label,\n.type-selector label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.account-selector select,\n.broker-selector select,\n.type-selector select {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  background: #ffffff;\n  color: #111827;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  min-width: 150px;\n}\n\n.account-selector select:hover,\n.broker-selector select:hover,\n.type-selector select:hover {\n  border-color: #9ca3af;\n}\n\n.account-selector select:focus,\n.broker-selector select:focus,\n.type-selector select:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.15);\n}\n\n.synthetic-checkbox {\n  display: flex;\n  align-items: center;\n}\n\n.synthetic-checkbox label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.synthetic-checkbox input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #667eea;\n}\n\n/* ── Table container ─────────────────────────────────────────────────────── */\n\n.open-positions-table-container {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  overflow-x: auto;\n  overflow-y: visible;\n  position: relative;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n/* ── Desktop scroll wrapper ──────────────────────────────────────────────── */\n\n.op-desktop {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* ── Table ───────────────────────────────────────────────────────────────── */\n\n.open-positions-table {\n  width: auto;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n  font-variant-numeric: tabular-nums;\n  table-layout: auto;\n}\n\n/* ── Table header — light gray, never gradient ───────────────────────────── */\n\n.open-positions-table thead {\n  background: #f9fafb;\n  border-bottom: 2px solid #e5e7eb;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.open-positions-table th {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  transition: background-color 0.15s;\n  font-variant-numeric: tabular-nums;\n}\n\n.open-positions-table th:hover {\n  background: #f3f4f6;\n}\n\n.sort-icon {\n  margin-left: 0.4rem;\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n.open-positions-table th:hover .sort-icon {\n  color: #6b7280;\n}\n\n/* ── Table body ──────────────────────────────────────────────────────────── */\n\n.open-positions-table tbody tr {\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.15s;\n}\n\n.open-positions-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.open-positions-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n/* ── Table cells ─────────────────────────────────────────────────────────── */\n\n.open-positions-table td {\n  padding: 0.4375rem 0.75rem;\n  color: #111827;\n  white-space: nowrap;\n  position: relative;\n  font-variant-numeric: tabular-nums;\n  text-align: left;\n  vertical-align: middle;\n}\n\n/* ── Option type — left-border accent ───────────────────────────────────── */\n\n.open-positions-table tbody tr.row-call {\n  border-left: 3px solid #3b82f6;\n}\n\n.open-positions-table tbody tr.row-put {\n  border-left: 3px solid #f97316;\n}\n\n.open-positions-table tbody tr.synthetic-row {\n  border-left: 3px solid #7c3aed;\n}\n\n/* ── Group / section headers ─────────────────────────────────────────────── */\n\n.group-header-row {\n  background: #f9fafb;\n  border-top: 2px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.group-header-cell {\n  padding: 0.375rem 0.75rem !important;\n  font-size: 0.6875rem !important;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #374151;\n  background: inherit;\n  line-height: 1.2;\n}\n\n/* Subtle tinted section headers — left-border accent instead of full fill */\n.group-header-row.short_calls-header {\n  border-left: 4px solid #dc2626;\n}\n.group-header-row.short_calls-header .group-header-cell {\n  color: #991b1b;\n}\n\n.group-header-row.long_calls-header {\n  border-left: 4px solid #3b82f6;\n}\n.group-header-row.long_calls-header .group-header-cell {\n  color: #1e40af;\n}\n\n.group-header-row.short_puts-header {\n  border-left: 4px solid #f97316;\n}\n.group-header-row.short_puts-header .group-header-cell {\n  color: #9a3412;\n}\n\n.group-header-row.long_puts-header {\n  border-left: 4px solid #059669;\n}\n.group-header-row.long_puts-header .group-header-cell {\n  color: #065f46;\n}\n\n.group-header-row.synthetic-header {\n  border-left: 4px solid #7c3aed;\n}\n.group-header-row.synthetic-header .group-header-cell {\n  color: #5b21b6;\n}\n\n.group-header-row.other-header {\n  border-left: 4px solid #6b7280;\n}\n.group-header-row.other-header .group-header-cell {\n  color: #374151;\n}\n\n/* ── Cell types ──────────────────────────────────────────────────────────── */\n\n.account-cell {\n  font-weight: 500;\n  color: #374151;\n}\n\n.symbol-cell {\n  font-weight: 600;\n  color: #111827;\n}\n\n.date-cell {\n  color: #374151;\n}\n\n.expiry-cell {\n  color: #374151;\n}\n\n.moneyness-cell {\n  text-align: center;\n}\n\n.number-cell {\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n\n.number-cell.positive {\n  color: #059669;\n  font-weight: 600;\n}\n\n.number-cell.negative {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.number-cell.vsp-orange {\n  color: #d97706;\n  font-weight: 600;\n}\n\n/* Tags cell — constrained width */\n.open-positions-table .tags-cell {\n  white-space: nowrap;\n  min-width: 60px;\n  max-width: 130px;\n}\n\n/* ── Delta / Greek colour indicators — soft modern tones ─────────────────── */\n\n.open-positions-table td.number-cell.delta-green {\n  background: rgba(5, 150, 105, 0.10);\n  color: #065f46;\n  font-weight: 600;\n}\n\n.open-positions-table td.number-cell.delta-orange {\n  background: rgba(217, 119, 6, 0.10);\n  color: #92400e;\n  font-weight: 600;\n}\n\n.open-positions-table td.number-cell.delta-red {\n  background: rgba(220, 38, 38, 0.10);\n  color: #991b1b;\n  font-weight: 600;\n}\n\n/* ── Moneyness badges ────────────────────────────────────────────────────── */\n\n.moneyness-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  white-space: nowrap;\n}\n\n.moneyness-badge.moneyness-green {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.moneyness-badge.moneyness-red {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.moneyness-badge.moneyness-orange {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.moneyness-badge.moneyness-gray {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n/* ── Total / summary rows ────────────────────────────────────────────────── */\n\n.total-row td {\n  font-weight: 700;\n  border-top: 2px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.total-label {\n  font-weight: 700;\n  color: #111827;\n}\n\n/* ── Section header (mobile section labels) ──────────────────────────────── */\n\n.section-header td {\n  background: #f9fafb;\n  font-weight: 700;\n  font-size: 0.6875rem;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 0.375rem 0.75rem;\n  border-top: 2px solid #e5e7eb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* ── Expand button ───────────────────────────────────────────────────────── */\n\n.expand-button {\n  background: #667eea;\n  color: #ffffff;\n  border: none;\n  border-radius: 4px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: bold;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.expand-button:hover {\n  background: #5a6fd8;\n}\n\n/* ── OptionStrat link ────────────────────────────────────────────────────── */\n\n.optionstrat-link {\n  color: #3b82f6;\n  text-decoration: none;\n  font-size: 0.75rem;\n}\n\n.optionstrat-link:hover {\n  text-decoration: underline;\n  color: #2563eb;\n}\n\n.optionstrat-nvt {\n  color: #9ca3af;\n  font-size: 0.75rem;\n}\n\n/* ── No tags indicator ───────────────────────────────────────────────────── */\n\n.no-tags {\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-style: italic;\n}\n\n/* ── Delta warning icon ──────────────────────────────────────────────────── */\n\n.delta-warning-icon {\n  color: #d97706;\n  margin-left: 4px;\n  font-size: 0.75rem;\n}\n\n/* ── Info icon ───────────────────────────────────────────────────────────── */\n\n.info-icon {\n  color: #9ca3af;\n  cursor: help;\n  font-size: 0.75rem;\n  margin-left: 4px;\n}\n\n/* ── Tooltip ─────────────────────────────────────────────────────────────── */\n\n.cell-tooltip {\n  position: absolute;\n  background: #111827;\n  color: #ffffff;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  z-index: 1000;\n  white-space: nowrap;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  pointer-events: none;\n  line-height: 1.4;\n}\n\n/* ── Short call exposure table ───────────────────────────────────────────── */\n\n.short-call-exposure-container {\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e5e7eb;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.short-call-exposure-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.8125rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.short-call-exposure-table th {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: #f9fafb;\n  border-bottom: 2px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.short-call-exposure-table td {\n  padding: 0.4375rem 0.75rem;\n  border-bottom: 1px solid #f3f4f6;\n  color: #111827;\n}\n\n.short-call-exposure-table tbody tr:hover {\n  background: #f9fafb;\n}\n\n.short-call-exposure-table th.sortable-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.15s;\n}\n\n.short-call-exposure-table th.sortable-header:hover {\n  background: #f3f4f6;\n}\n\n.short-call-exposure-table th.sortable-header .sort-icon {\n  display: inline-block;\n  margin-left: 4px;\n  font-size: 0.9em;\n  vertical-align: middle;\n  color: #9ca3af;\n}\n\n.short-call-exposure-table th.sortable-header:hover .sort-icon {\n  color: #6b7280;\n}\n\n.short-call-exposure-table .exposure-cell {\n  color: #dc2626;\n  font-weight: 600;\n  text-align: right;\n}\n\n.short-call-exposure-table .total-row {\n  font-weight: 700;\n  background: #f9fafb;\n  border-top: 2px solid #e5e7eb;\n}\n\n.short-call-exposure-table .total-row .total-exposure {\n  color: #dc2626;\n  font-weight: 700;\n}\n\n/* ── Loading / error / empty ─────────────────────────────────────────────── */\n\n.loading {\n  padding: 3rem 1rem;\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n}\n\n.error {\n  padding: 1rem;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  border-radius: 8px;\n  color: #b91c1c;\n  margin-bottom: 1rem;\n}\n\n.empty-state {\n  padding: 3rem 1rem;\n  text-align: center;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n/* ── Mobile / Desktop split ──────────────────────────────────────────────── */\n\n.op-mobile {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .op-desktop {\n    display: none;\n  }\n\n  .op-mobile {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .open-positions-container {\n    padding: 0;\n    background: #f5f7fa;\n  }\n\n  .open-positions-content {\n    padding: 0;\n  }\n\n  .short-call-exposure-container {\n    margin-top: 0;\n    padding: 0;\n    border-radius: 0;\n    box-shadow: none;\n    border: none;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  .open-positions-controls {\n    flex-direction: column;\n    gap: 6px;\n    padding: 8px;\n    margin-bottom: 0;\n    border-radius: 0;\n    box-shadow: none;\n    border-left: none;\n    border-right: none;\n    border-top: none;\n  }\n\n  .open-positions-controls .account-selector,\n  .open-positions-controls .broker-selector,\n  .open-positions-controls .type-selector {\n    width: 100%;\n  }\n\n  .open-positions-controls select {\n    width: 100%;\n    min-width: unset;\n    box-sizing: border-box;\n    padding: 6px 8px;\n    font-size: 0.8125rem;\n  }\n\n  .account-selector select,\n  .broker-selector select,\n  .type-selector select {\n    min-width: unset;\n  }\n\n  .open-positions-controls .synthetic-checkbox {\n    align-self: flex-start;\n  }\n\n  /* Mobile table */\n  .op-mobile-table {\n    width: 100%;\n    min-width: 310px;\n    border-collapse: collapse;\n    font-size: 0.75rem;\n    font-variant-numeric: tabular-nums;\n    table-layout: auto;\n  }\n\n  .op-mobile-table thead {\n    background: #f9fafb;\n    border-bottom: 2px solid #e5e7eb;\n  }\n\n  .op-mobile-table th {\n    padding: 0.375rem 0.5rem;\n    background: #f9fafb;\n    text-align: left;\n    font-size: 0.625rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #374151;\n    border-bottom: 2px solid #e5e7eb;\n    white-space: nowrap;\n  }\n\n  .op-mobile-table td {\n    padding: 0.375rem 0.5rem;\n    border-bottom: 1px solid #f3f4f6;\n    vertical-align: middle;\n    white-space: nowrap;\n    color: #111827;\n  }\n\n  .op-mobile-table td:first-child {\n    font-weight: 600;\n  }\n\n  .op-mobile-table tbody tr:hover {\n    background: #f9fafb;\n  }\n\n  .op-mobile-table .positive {\n    color: #059669;\n    font-weight: 600;\n  }\n\n  .op-mobile-table .negative {\n    color: #dc2626;\n    font-weight: 600;\n  }\n\n  .op-mobile-table .row-call {\n    border-left: 3px solid #3b82f6;\n  }\n\n  .op-mobile-table .row-put {\n    border-left: 3px solid #f97316;\n  }\n\n  .op-mobile-table .section-header td {\n    background: #f9fafb;\n    font-weight: 700;\n    font-size: 0.6rem;\n    color: #374151;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    padding: 0.375rem 0.5rem;\n    border-top: 2px solid #e5e7eb;\n    border-left: none;\n  }\n}\n\n/* ── Wide screens ────────────────────────────────────────────────────────── */\n\n@media (max-width: 1400px) {\n  .open-positions-table {\n    font-size: 0.75rem;\n  }\n\n  .open-positions-table th,\n  .open-positions-table td {\n    padding: 0.375rem 0.5rem;\n  }\n}\n\n/* Live positions (position.is_live - seen via the IBKR API today, merged in\n   by OpenPositionViewSet, not yet in tonight's Flex import). Same row/table\n   as every other position - just a tint + a small badge, not a separate\n   section. */\n.live-position-row {\n  background-color: #eef4ff;\n}\n\n.live-position-badge {\n  display: inline-block;\n  margin-left: 0.4rem;\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: #26314f;\n  background: #c9dcff;\n  border-radius: 4px;\n  padding: 0.05rem 0.35rem;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
